import {
  BLOG,
  EVENT,
  NEWS,
  PERSON,
  PROJECT,
  translate,
} from "shared/utils/translate";
import { SiteLink } from "shared/components/SiteLink";
import { formatDate } from "shared/utils/formatDate";
import { useRouter } from "next/router";
import styles from "./HeroHead.module.css";

const typesWithLabel = [PROJECT, PERSON, EVENT, NEWS, BLOG];

export const HeroHeadContainer = (props) => (
  <div className={styles.heroHeadContainer}>
    <HeroHead {...props} />
  </div>
);

export const HeroHead = ({ type = "", date, location }) => {
  const { locale } = useRouter();

  const label =
    typesWithLabel.indexOf(
      type.replace("clariah.", "").replace("ineo.", "").toUpperCase()
    ) > -1
      ? translate(type.toUpperCase(), locale)
      : null;

  if (!label && !date) return null;

  const meta = [formatDate(date, locale), location].filter(Boolean);

  return (
    <div className={styles.head}>
      {label && (
        <SiteLink className={styles.label} type={type} href="">
          {label}
        </SiteLink>
      )}

      {meta && (
        <ul className={styles.meta}>
          {meta.map((item) => (
            <li key={item}>{item}</li>
          ))}
        </ul>
      )}
    </div>
  );
};
